<template>
  <div class="s-wrapper">
    <Search v-if="hasSearch" />
    <div class="s-container">
      <Aside v-if="hasSearch" />
      <Notices />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .viewer-element {
    .s-container {
      @include wrapper;
      display: flex;
      margin-top: rem(20);
      @include tablet {
        margin-top: rem(40);
      }
    }
  }
</style>

<script>
import Search from '@/front/components/Search';
import Aside from '@/front/components/Aside';
import Notices from '@/front/components/Notices';
import ConfigService from '@/front/services/config';
import SearchService from '@/front/services/search';

export default {
  name: 'FrontListNotices',
  components: {
    Search,
    Aside,
    Notices,
  },
  data: () => ({
    query: '',
    historics: SearchService.historic,
    hasSearch: null
  }),
  created () {
    const configGlobal = this.$store.state.config;
    ConfigService.parse( configGlobal );
    this.hasSearch = (ConfigService.get('isCollectionView') && ConfigService.get('searchEnabled')) || !ConfigService.get('isCollectionView');
  },
  mounted() {
    SearchService.init();
  },
  methods: {}
}
</script>
